<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/funnel-builder-with-crm.mjs";
</script>
